import styled from "styled-components";
import OxygenButton from "@8x8/oxygen-button";
import OxygenTag from "@8x8/oxygen-tag";

export const Button = styled(OxygenButton)`
  margin-left: ${(props) =>
    props?.marginLeft ? props.marginLeft + "px" : "unset"};
  margin-right: ${(props) =>
    props?.marginRight ? props.marginRight + "px" : "unset"};
  margin-top: ${(props) =>
    props?.marginTop ? props.marginTop + "px" : "unset"};
  margin-bottom: ${(props) =>
    props?.marginBottom ? props.marginBottom + "px" : "unset"};
`;

export const Tag = styled(OxygenTag)`
  margin-left: ${(props) =>
    props?.marginLeft ? props.marginLeft + "px" : "unset"};
  margin-right: ${(props) =>
    props?.marginRight ? props.marginRight + "px" : "unset"};
  margin-top: ${(props) =>
    props?.marginTop ? props.marginTop + "px" : "unset"};
  margin-bottom: ${(props) =>
    props?.marginBottom ? props.marginBottom + "px" : "unset"};
`;
